module.exports = __webpack_public_path__ + "img/icon_60px_27_blue.c21f068e.svg";